var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "#FDDED4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C13.235 7 11 9.235 11 12C11 14.765 13.235 17 16 17C18.765 17 21 14.765 21 12C21 9.235 18.765 7 16 7ZM18.15 14.15C17.955 14.345 17.64 14.345 17.445 14.15L16 12.705L14.555 14.15C14.36 14.345 14.045 14.345 13.85 14.15C13.655 13.955 13.655 13.64 13.85 13.445L15.295 12L13.85 10.555C13.655 10.36 13.655 10.045 13.85 9.85C14.045 9.655 14.36 9.655 14.555 9.85L16 11.295L17.445 9.85C17.64 9.655 17.955 9.655 18.15 9.85C18.345 10.045 18.345 10.36 18.15 10.555L16.705 12L18.15 13.445C18.34 13.635 18.34 13.955 18.15 14.15Z",
    fill: "#B92043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeFailed);
export default __webpack_public_path__ + "static/media/Badge_failed.1e377dc354bd1c727c592d63a322feb6.svg";
export { ForwardRef as ReactComponent };